import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, FormsModule, ReactiveFormsModule} from "@angular/forms";
import {MatPaginator, MatPaginatorModule, PageEvent} from "@angular/material/paginator";
import {MatTooltip, MatTooltipModule} from "@angular/material/tooltip";
import {NgClass, NgForOf, NgIf, TitleCasePipe} from "@angular/common";
import {VexBreadcrumbsComponent} from "@vex/components/vex-breadcrumbs/vex-breadcrumbs.component";
import {VexPageLayoutComponent} from "@vex/components/vex-page-layout/vex-page-layout.component";
import {VexSecondaryToolbarComponent} from "@vex/components/vex-secondary-toolbar/vex-secondary-toolbar.component";
import {environment} from "../../../../environments/environment";
import {AuthService} from "../../../shared/services/auth.service";
import {ActivatedRoute, Router} from "@angular/router";
import {BookService} from "../../../shared/services/book.service";
import {EmployeeService} from "../../../shared/services/employee.service";
import {Helper} from "../../../shared/constants/helper";
import {MatButtonModule} from "@angular/material/button";
import {MatIconModule} from "@angular/material/icon";
import {MatOptionModule} from "@angular/material/core";
import {MatSelectModule} from "@angular/material/select";
import {MatDialogModule} from "@angular/material/dialog";
import {MatCardModule} from "@angular/material/card";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatInputModule} from "@angular/material/input";
import {SharedModule} from "../../../shared/shared.module";
import {TooltipModule} from "ngx-bootstrap/tooltip";
import {MatSidenavModule} from "@angular/material/sidenav";

@Component({
  selector: 'vex-opaq',
  standalone: true,
  imports: [
    FormsModule,
    MatButtonModule,
    MatIconModule,
    MatOptionModule,
    MatPaginatorModule,
    MatSelectModule,
    MatTooltipModule,
    NgForOf,
    NgIf,
    ReactiveFormsModule,
    VexBreadcrumbsComponent,
    VexPageLayoutComponent,
    VexSecondaryToolbarComponent,
    MatDialogModule,
    MatCardModule,
    MatSelectModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatInputModule,
    NgClass,
    SharedModule,
    TooltipModule,
    MatSidenavModule,
    MatButtonModule,
    TitleCasePipe
  ],
  templateUrl: './opaq.component.html',
  styleUrl: './opaq.component.scss'
})
export class OpaqComponent implements OnInit {
  searchForm: FormGroup;
  books: any[] = [];
  openedDrawer: number | null = null;
  user: any;
  baseUrl: any = environment.s3_bucket_url;
  pagination: any = {
    pageSize: 50,
    pageSizeOptions: [50, 100, 150, 200, 250],
    pageIndex: 0,
    hidePageSize: false,
    length: 0,
    pageEvent: PageEvent,
    showPageSizeOptions: true,
    showFirstLastButtons: true,
    disabled: false,
    totalCount: 0
  };
  pageExtras: any = {
    isBusy: false,
    showImage: true
  };
  searchTimeOut: any;
  perSlide: number = 16;
  slideData: any[] = [];
  showNextBtn: boolean = false;
  showPrevBtn: boolean = false;
  currentSlideIndex: any = 0;

  constructor(
    private authService: AuthService,
    private router: Router,
    private bookService: BookService,
    private formBuilder: FormBuilder,
    private route: ActivatedRoute
  ) {
  }

  ngOnInit(): void {
    this.refresh();
  }

  refresh(): void {
    this.searchForm = this.formBuilder.group({search_key: ['']});
  }



  getBooks(): void {
    clearTimeout(this.searchTimeOut);
    this.searchTimeOut = setTimeout(() => {
      this.get();
    }, 800);
  }

  get(): void {
    const params: any = {
      search_key: this.searchForm && this.searchForm.value && this.searchForm.value.search_key ? this.searchForm.value.search_key : '',
      per_page: this.pagination.pageSize,
      page: this.pagination.pageIndex + 1
    };
    this.books = [];
    params.search_key = params.search_key.trim();
    if (params.search_key.length === 0) return;
    this.pageExtras.showImage = false;
    this.pageExtras.isBusy = true;
    this.bookService.getBookSearch(params).subscribe((data: any) => {
      if (data && data['data'].length > 0) {
        this.books = data['data'];
        this.pagination.length = data.total;
      }
      this.pageExtras.isBusy = false;
    }, () => {
      this.pageExtras.isBusy = false;
      this.books = [];
    });
  }

  toggleDrawer(index: number | null): void {
    if (index !== null) {
      let book: any = this.books[index];
      let bookStocks: any = [];
      if (book && book?.book_stocks && book?.book_stocks?.length > 0) {
        book.book_stocks.forEach((stock: any) => {
          if (stock?.racks) {
            let racks = JSON.parse(stock?.racks);
            bookStocks = [...bookStocks, ...racks];
          }
        });
        this.books[index]['book_positions'] = bookStocks;
      } else {
        this.books[index]['book_positions'] = [];
      }
      this.currentSlideIndex = 0;
      if (bookStocks.length > this.perSlide) {
        this.showNextBtn = true;
        this.slideData = bookStocks.slice(0, this.perSlide);
      } else {
        this.slideData = bookStocks;
        this.showNextBtn = false;
      }
      this.showPrevBtn = false;
      this.openedDrawer = index;
    } else {
      this.openedDrawer = null;
    }
  }

  showNextSlide(): void {
    const totalSlides =
      this.books[this.openedDrawer]?.book_positions?.length || 0;
    const nextIndex: any = this.currentSlideIndex + this.perSlide;
    if (nextIndex < totalSlides) {
      this.slideData = this.books[this.openedDrawer].book_positions.slice(nextIndex, nextIndex + this.perSlide);
      this.currentSlideIndex = nextIndex;
      this.showPrevBtn = true;
    }
    if (nextIndex + this.perSlide >= totalSlides) {
      this.showNextBtn = false;
    }
  }

  showPreviousSlide(): void {
    const prevIndex: any = this.currentSlideIndex - this.perSlide;
    if (prevIndex >= 0) {
      this.slideData = this.books[this.openedDrawer].book_positions.slice(prevIndex, prevIndex + this.perSlide);
      this.currentSlideIndex = prevIndex;
      this.showNextBtn = true;
    }
    if (prevIndex === 0) {
      this.showPrevBtn = false;
    }
  }

  handlePageEvent(e: PageEvent): void {
    this.pagination.pageEvent = e;
    this.pagination.length = e.length;
    this.pagination.pageSize = e.pageSize;
    this.pagination.pageIndex = e.pageIndex;
    this.get();
  }
}
